var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPassportFilled = function SvgPassportFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 143,
    viewBox: "0 0 126 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#svg-public/img/icons/documents/passport_filled.svg__filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 25,
    width: 46,
    height: 58,
    rx: 4,
    fill: "#005FF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 23.4959H73.2577L73.2508 23.4469C72.9451 21.259 70.9236 19.7332 68.7357 20.039L44 23.4959Z",
    fill: "#005FF9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 67.6876,
    width: 14.25,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53,
    y: 62.5058,
    width: 19.4318,
    height: 2,
    rx: 1,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.0001 46C72.0001 50.9706 67.9706 55 63.0001 55C58.0295 55 54.0001 50.9706 54.0001 46C54.0001 41.0294 58.0295 37 63.0001 37C67.9706 37 72.0001 41.0294 72.0001 46ZM63.0001 52.8994C66.8105 52.8994 69.8995 49.8104 69.8995 46C69.8995 42.1896 66.8105 39.1006 63.0001 39.1006C59.1896 39.1006 56.1007 42.1896 56.1007 46C56.1007 49.8104 59.1896 52.8994 63.0001 52.8994Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "svg-public/img/icons/documents/passport_filled.svg__filter0_d",
    x: 0,
    y: 0,
    width: 126,
    height: 143,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.227451 0 0 0 0 0.596078 0 0 0 0.28 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
};
export { SvgPassportFilled as ReactComponent };